import styled from 'styled-components'
import MttGrid from 'components/Material/MttGrid/MttGrid'

export const TextContainer = styled(MttGrid)`
  width: 100%;
  height: 56px;
  padding: 4px;

  max-width: 300px;

  .MuiFormControl-root {
    width: 100%;
  }
`

export const ContainerButton = styled(MttGrid)`
  display: flex;
  justify-content: space-between;
  justify-self: flex-end;
  padding: 8px 0;
`

export const ContainerOptionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 4px;
`

export const ContainerOptionContent = styled.div`
  display: flex;
  align-items: center;
  padding: 4px;

  justify-content: space-between;
`

export const OptionIndexAndTip = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`

export const RulesRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Rules = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`

export const RulesContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  padding: 0px 16px;
`

export const HeaderSpan = styled.span`
  margin-left: 64px;
`

export const ConditionalContainer = styled.div`
  padding: 4px;

  .MuiOutlinedInput-root {
    max-width: 70px;
    height: 34px;
  }
`

export const Container = styled(MttGrid)`
  width: calc(100% - 32px);
  min-height: 48px;

  padding: 8px;
  border-radius: 4px;

  border: 1px solid #0000001f;
  background-color: #ffffff;

  display: flex;
  flex-direction: column;

  margin-top: 8px;
`
